<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box box-primary">
        <div class="box-header with-border">
            
          <h3 class="box-title">Branch Ledger List</h3>
          <span class="float-right">
            <button v-if="canAccess('branch-ledger-create')" type="button" class="btn btn-xs btn-success" @click="newModal"><i class="fa fa-plus"></i></button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
          
        </div>
        
        <div class="box-body">
          <div class="form-group col-sm-3" v-if="canAccess('branch-view-any')">
                <label
                >Branch Name <span class="red">*</span></label
                >
                <select
                v-model="form.branch_id"
                name="branch_id"
                class="form-control"
                :class="{
                    'is-invalid': form.errors.has('branch_id'),
                }"
                @change="loadData"
                required
                >
                <option
                    v-if="!form.branch_id"
                    selected
                    value=""
                >
                    Select Company Branch
                </option>
                <option
                    :value="branch.id"
                    v-for="branch in branches"
                    :key="branch.id"
                >
                    {{ branch.name }}
                </option>
                </select>
                <has-error
                :form="form"
                field="branch_id"
                ></has-error>
            </div><br><br><br><br>
          <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :line-numbers="true"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'BalanceAmt'">
                    <span v-show="props.row.balanceAmt > 0">{{props.row.balanceAmt}}</span>
                    <!-- <span v-show="props.row.balanceAmt < 0">{{props.row.balanceAmt}}</span> -->
                    
                  </span>
                  <span v-if="props.column.field == 'Status'">
                    <span v-if="props.row.status == 'active'" class="label label-success" >Active</span>
                    <span v-else class="label label-danger">InActive</span>
                  </span>
                  <span v-if="props.column.field == 'id'">
                    <button v-if="canAccess('branch-ledger-update')" type="button" @click="editModal(props.row)" class="btn btn-success btn-sm">
                      <i class="fa fa-pencil"></i>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Group
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

  </section>
  
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Add New</h4>
              <h4 v-show="editMode" class="modal-title">Update</h4>
            </div>
            <form @submit.prevent="editMode ? updateGroup() : createBranchLedger()">
              <div class="modal-body">
                <!-- right column -->
                
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group" v-if="editMode === false">
                            <label
                            >Branch Name <span class="red">*</span></label
                            >
                            <select
                            v-model="form.branch_id"
                            name="branch_id"
                            class="form-control"
                            :class="{
                                'is-invalid': form.errors.has('branch_id'),
                            }"
                            @change="loadData"
                            required
                            >
                            <option
                                v-if="!form.branch_id"
                                selected
                                value=""
                            >
                                Select Company Branch
                            </option>
                            <option
                                :value="branch.id"
                                v-for="branch in branches"
                                :key="branch.id"
                            >
                                {{ branch.name }}
                            </option>
                            </select>
                            <has-error
                            :form="form"
                            field="branch_id"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Opening Balance <span class="red">*</span></label>
                            <input v-model="form.openingAmt" type="text" name="openingAmt" class="form-control" :class="{ 'is-invalid': form.errors.has('openingAmt') }" />
                            <has-error :form="form" field="openingAmt"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group" v-if="editMode === false">
                            <label
                            >Ledger Name <span class="red">*</span></label
                            >
                            <select
                            v-model="ledger"
                            name="ledger_id"
                            class="form-control"
                            :class="{
                                'is-invalid': form.errors.has('ledger_id'),
                            }"
                            @change="getAccount()"
                            required
                            >
                            <option
                                v-if="!ledger"
                                selected
                                value=""
                            >
                                Select Ledger
                            </option>
                            <option
                                :value="ledger"
                                v-for="ledger in ledgers"
                                :key="ledger.id"
                            >
                                {{ ledger.name }}
                            </option>
                            </select>
                            <has-error
                            :form="form"
                            field="ledger_id"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="editMode === false">
                            <label>Description <span class="red">*</span></label>
                            <textarea v-model="form.remark" name="remark" class="form-control" :class="{ 'is-invalid': form.errors.has('remark') }" ></textarea>
                            <has-error :form="form" field="remark"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button v-show="!editMode" type="submit" class="btn btn-success" > CREATE </button>
                <button v-show="editMode" type="submit" class="btn btn-success"> UPDATE </button>
                <button type="button" class="btn btn-danger" data-dismiss="modal" > CANCEL</button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      
</div>
</template>

<script>
export default {
  name: 'Group',
  data () {
    return {
      editMode: false,
      branches: [],
      ledgers: [],
      ledger: {},
      form: new Form({
        id: '',
        branch_id: '',
        ledger_id: '',
        group_id: '',
        remark: '',
        openingAmt: 0,
        balanceAmt: 0,
        type: '',
        status: ''
      }),
      columns: [
        {
          label: 'Branch',
          field: 'branch.name'
        },
        {
          label: 'Ledger',
          field: 'ledger.name'
        },
        {
          label: 'Opening Amount',
          field: 'openingAmt'
        },
        {
          label: 'Balance Amount',
          field: 'BalanceAmt'
        },
        {
          label: 'Remark',
          field: 'remark'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },

    createBranchLedger () {
      this.$axios
        .post('branchledger', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Branch Ledger Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },

    editModal (row) {
      console.log(row)
      this.editMode = true
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.openingAmt = row.openingAmt
      console.log('data check')
      console.log(row.ledger)
      this.ledger = _.find(this.ledgers, function (o) { return o.id === row.ledger_id })
    },
    updateGroup () {
      // console.log('update data')

      this.$axios
        .put('branchledger/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Branch ledger Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getAccount () {
      // console.log('ledger =========')
      // console.log(this.ledger)
      this.form.group_id = this.ledger.group_id
      this.form.ledger_id = this.ledger.id
      this.form.balanceAmt = 0
    },
    loadLedger () {
      this.$axios
        .get('ledger?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.ledgers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      var c = JSON.parse(localStorage.user)
      var pageUrl = 'branchledger?all=all'
      if (c.type === 'admin') {
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
      }
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          pageUrl += `&branch_id=${c.agent_profile.branch_id}`
        } else {
          pageUrl += `&agent_id=${c.id}`
        }
      }
      this.$axios
        .get(pageUrl, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    this.loadBranch()
    this.loadLedger()
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// BranchLedger.vue?4407f4f4